export default {
  apiUrl: "https://api.koletra.com/api",
  isFinekraLogoApiUrl: "https://logo-api.koletra.com/api",
  headers: {
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  },
  demoUrl: "https://koletra.com/",
  frontEndUrl: "https://panel.koletra.com/",
  supportPanelImgUrl: "https://api.koletra.com",
  renderNotifications: false,
};
